import { SRMStatus } from '@scaleup/models';
import { toTitleCase } from '../../utils';

export const CapitalRequestMatchDealTracker = ({
  status,
}: {
  status: string;
}) => {
  return (
    <div className="inline-flex	 rounded-[1rem] h-[40px] gap-[1px]">
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning rounded-s-[16px] bg-warning-75 h-[40px] ${status === SRMStatus.OPPORTUNITY_AVAILABLE ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-text-disabled font-black text-[10px]">1</span>
          {status === SRMStatus.OPPORTUNITY_AVAILABLE && (
            <p className="text-white text-sm font-medium text-[10px]">
              Opportunity Available
            </p>
          )}
        </div>
        {status !== SRMStatus.OPPORTUNITY_AVAILABLE && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Opportunity Available
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-blue-500 h-[40px] ${status === SRMStatus.QUESTIONS ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-tertiary-700 font-black text-[12px]">2</span>
          {status === SRMStatus.QUESTIONS && (
            <p className="text-white text-sm font-medium text-[10px]">
              Questions
            </p>
          )}
        </div>
        {status !== SRMStatus.QUESTIONS && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Questions
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-primary-500 h-[40px] ${status === SRMStatus.DEAL_PROSPECT ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-primary-700 text-xs">3</span>
          {status === SRMStatus.DEAL_PROSPECT && (
            <p className="text-white text-sm font-medium text-[10px]">
              Deal Prospect
            </p>
          )}
        </div>
        {status !== SRMStatus.DEAL_PROSPECT && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Deal Prospect
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-green-500 h-[40px] ${status === SRMStatus.ACCEPTED ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-green-700 text-xs">4</span>
          {status === SRMStatus.ACCEPTED && (
            <p className="text-white text-sm font-medium text-[10px]">
              Introductions
            </p>
          )}
        </div>
        {status !== SRMStatus.ACCEPTED && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Introductions
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning rounded-e-[16px] bg-secondary-500 h-[40px] ${
            status === SRMStatus.DEAL_WON || status == SRMStatus.DEAL_LOST
              ? 'w-[168px]'
              : 'w-[83px] opacity-25'
          }`}
        >
          <span className="text-secondary-700 text-xs">5</span>
          {(status === SRMStatus.DEAL_WON ||
            status === SRMStatus.DEAL_LOST) && (
            <p className="text-white text-sm font-medium text-[10px]">
              {toTitleCase(status.split('_').join(' '))}
            </p>
          )}
        </div>
        {status !== SRMStatus.DEAL_WON && status !== SRMStatus.DEAL_LOST && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Deal Status
          </span>
        )}
      </div>
    </div>
  );
};
